/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Classification_Template_Row_Identifiers_LabelInputs */

const en_classification_template_row_identifiers_label = /** @type {(inputs: Classification_Template_Row_Identifiers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Row identifier columns`)
};

const nl_classification_template_row_identifiers_label = /** @type {(inputs: Classification_Template_Row_Identifiers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolommen voor rij-identificatie`)
};

/**
* | output |
* | --- |
* | "Row identifier columns" |
*
* @param {Classification_Template_Row_Identifiers_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const classification_template_row_identifiers_label = /** @type {((inputs?: Classification_Template_Row_Identifiers_LabelInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Classification_Template_Row_Identifiers_LabelInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_classification_template_row_identifiers_label(inputs)
	return en_classification_template_row_identifiers_label(inputs)
});